import { useFeatureFlagClient } from '@/composables/featureFlags.js'
import { isSamePage } from '@/utils/middleware.js'
export default defineNuxtRouteMiddleware(async (to, from) => {
  if (isSamePage(to, from) || to.meta?.skipMiddleware) {
    return
  }

  // skip on login and 2FA verify pages - user is not yet authenticated
  if (
    to.name === 'provetId-auth-login' ||
    to.name === 'provetId-auth-login-verify'
  ) {
    return
  }

  const featureFlagClient = useFeatureFlagClient(to)

  if (featureFlagClient?.isIdentified) {
    return
  }

  await featureFlagClient?.initialize()
})
